import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppointmentRow} from "../lib/appointment-table";
import {firstValueFrom} from "rxjs";
import {environment} from "../../environments/environment";
import {Patient} from "@allaihealth/util";

/** Service that loads and caches all appointments in the appointment list page */
@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	constructor(private http: HttpClient) {
	}

	async resendIntake(row: AppointmentRow): Promise<boolean> {
		try {
			await firstValueFrom(this.http.post(`${environment.apiUrl}/appointment/${row.appointmentId}/resend`, {}));
		}
		catch(error) {
			console.error("Failed to resend intake", error);
			return false;
		}
		return true;
	}

	public validateEmail(patient:Patient) {
		return patient.email?.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ ) && patient.subscribed_to_email;
	}

	public validateSms(patient: Patient) {
		return patient.phone?.trim().match(/^\+1\d{10}$/) != null && patient.subscribed_to_sms;
	}
}
